import { render, staticRenderFns } from "./abstract-course-badge.vue?vue&type=template&id=470703ea&scoped=true"
import script from "./abstract-course-badge.vue?vue&type=script&lang=js"
export * from "./abstract-course-badge.vue?vue&type=script&lang=js"
import style0 from "./abstract-course-badge.vue?vue&type=style&index=0&id=470703ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470703ea",
  null
  
)

export default component.exports